import { AgentMessageType } from "@vertesia/common"
import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"

import { AgentMessage } from "@models/agents"

dayjs.extend(relativeTime)

export function insertMessageInTimeline(arr: AgentMessage[], m: AgentMessage) {
    const t = typeof m.timestamp === "number" ? m.timestamp : new Date(m.timestamp).getTime()
    const idx = arr.findIndex((a) => {
        const at = typeof a.timestamp === "number" ? a.timestamp : new Date(a.timestamp).getTime()
        return at > t
    })
    if (idx === -1) {
        arr.push(m)
    } else {
        arr.splice(idx, 0, m)
    }
}

export function isInProgress(messages: AgentMessage[]) {
    if (!messages.length) {
        return true
    }

    const workstreamMessages = new Map<string, AgentMessage[]>()

    messages.forEach((message) => {
        const workstreamId = getWorkstreamId(message)
        if (!workstreamMessages.has(workstreamId)) {
            workstreamMessages.set(workstreamId, [])
        }
        workstreamMessages.get(workstreamId)!.push(message)
    })

    if (workstreamMessages.size === 1 && !workstreamMessages.has("main")) {
        const onlyWorkstreamId = workstreamMessages.keys().next().value || "unknown"

        const onlyWorkstreamMsgs = workstreamMessages.get(onlyWorkstreamId)!
        const lastMessage = onlyWorkstreamMsgs[onlyWorkstreamMsgs.length - 1]

        return ![AgentMessageType.COMPLETE, AgentMessageType.IDLE, AgentMessageType.REQUEST_INPUT].includes(lastMessage.type)
    }

    if (workstreamMessages.has("main")) {
        const mainWorkstreamMsgs = workstreamMessages.get("main")!

        if (mainWorkstreamMsgs.length === 0) {
            return true
        }

        const lastMainMessage = mainWorkstreamMsgs[mainWorkstreamMsgs.length - 1]
        return [AgentMessageType.COMPLETE, AgentMessageType.IDLE, AgentMessageType.REQUEST_INPUT].includes(lastMainMessage.type)
    }

    for (const [, msgs] of workstreamMessages.entries()) {
        if (msgs.length > 0) {
            const lastMessage = msgs[msgs.length - 1]
            if ([AgentMessageType.COMPLETE, AgentMessageType.IDLE, AgentMessageType.REQUEST_INPUT].includes(lastMessage.type)) {
                return true
            }
        }
    }

    return false
}

export function getWorkstreamId(message: AgentMessage): string {
    if (message.workstream_id) {
        return message.workstream_id
    }

    return "main"
}
